import { Form, Input, Button, Switch, Select } from "antd";
import { useEffect } from "react";
import EmployeeLocations, {
  hasValidEmployeeLocations,
  normalizeEmployeeLocations,
} from "./EmployeeLocations";

function EditCrewMember({ member, onClose, onSubmit, info, zones = [], isSuperAdmin = false }) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      ...member,
      zoneId: member?.zone?.id ? Number(member.zone.id) : undefined,
      locations: normalizeEmployeeLocations(member),
    });
  }, [member]);

  const handleSubmit = (values) => {
    const memberFields = { ...member };
    delete memberFields.latitude;
    delete memberFields.longitude;
    delete memberFields.locations;
    const updatedMember = {
      ...memberFields,
      ...values,
      locations: values.locations.map(({ latitude: lat, longitude: lng }) => ({
        latitude: Number(lat),
        longitude: Number(lng),
      })),
    };
    if (isSuperAdmin && values.zoneId) {
      const selected = zones.find((z) => z.id == values.zoneId);
      updatedMember.zoneId = selected?.id;
      updatedMember.zoneName = selected?.name;
      updatedMember.zone = { id: selected?.id, name: selected?.name };
    }
    onSubmit(updatedMember);
    onClose();
  };

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ ...member, zoneId: member?.zoneId }}
      >
        <Form.Item label="Name" name="employeeName">
          <Input />
        </Form.Item>

        <Form.Item label="Father's Name" name="employeeFatherName">
          <Input />
        </Form.Item>

        <Form.Item label="Mobile" name="mobileNumber">
          <Input />
        </Form.Item>
        <Form.Item
          label="Employee Locations"
          name="locations"
          rules={[
            {
              validator: (_, locations) =>
                hasValidEmployeeLocations(locations)
                  ? Promise.resolve()
                  : Promise.reject(new Error("Enter 1 to 5 complete, valid coordinate pairs")),
            },
          ]}
        >
          <EmployeeLocations />
        </Form.Item>
        {/* ✅ New Switch for Photo Change Restriction */}
        <Form.Item
          label="Photo Change Restricted"
          name="registeringPhotoRestricted"
          valuePropName="checked" // bind Switch checked state
        >
          <Switch
            checkedChildren="Restricted"
            unCheckedChildren="Allowed"
          />
        </Form.Item>
        <Form.Item
          label="Geo Fencing"
          name="geofencingOn"
          valuePropName="checked" // bind Switch checked state
        >
          <Switch
            checkedChildren="ON"
            unCheckedChildren="OFF"
          />
        </Form.Item>
        {isSuperAdmin && (
          <Form.Item label="Zone" name="zoneId">
            <Select
              placeholder="Select Zone"
              allowClear
              options={zones.map((z) => ({ label: z.name, value: Number(z.id) }))}
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>
        )}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save Changes
          </Button>
        </Form.Item>
      </Form>

      <span>{info}</span>
    </>
  );
}

export default EditCrewMember;
